import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { WidgetComponent } from '..';
import { Subscription } from 'rxjs';

import { DashboardDataService } from '@widgets/services/dashboard-data.service';
import { StoreService } from 'core/services';

@Component({
  selector: 'lms-best-comments-widget',
  templateUrl: './best-comments-widget.component.html',
  styleUrls: ['./best-comments-widget.component.scss']
})
export class BestCommentsWidgetComponent implements WidgetComponent, OnInit, OnDestroy {
  @Input() data: any;
  public listId = 'BEST_COMMENTS' + Date.now();
  public bestCommentsSubscription: Subscription;
  public activeIndex: number = 0;
  public comments: any[] = [];
  private tooltipSubscription: Subscription = new Subscription();
  public tooltipText: string;

  constructor(public dashboardService: DashboardDataService) {}

  ngOnInit() {
    this.bestCommentsSubscription = this.dashboardService
      .getBestComments({ ...this.data.query })
      .subscribe((comments) => {
        this.comments = comments;
        /*{_id: '5b3354fbd7a7cf0011a195a5',
            groupName: 'Prueba Ana',
            userName: 'ijabary+adatablet2@game-learn.com',
            gameName: 'ADA',
            created_at: '2018-06-27T09:12:27.885Z',
            opinion: 10,
             comments: 'bla1'
        }*/
      });

    this.tooltipSubscription = StoreService.get(this.data.action).subscribe((tooltipText) => {
      this.tooltipText = tooltipText[this.data.key];
    });
  }

  ngOnDestroy() {
    this.bestCommentsSubscription.unsubscribe();
    this.tooltipSubscription.unsubscribe();
  }

  previous() {
    if (this.activeIndex === 0) {
      this.activeIndex = this.comments.length - 1;
    } else {
      this.activeIndex--;
    }
  }

  next() {
    if (this.activeIndex === this.comments.length - 1) {
      this.activeIndex = 0;
    } else {
      this.activeIndex++;
    }
  }
}
